/**
 * @generated SignedSource<<2d2208ed2f5636552f294f1e4c92f1c0>>
 * @relayHash 9b5335baab0566640cfa28c329582507
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9b5335baab0566640cfa28c329582507

import type { ConcreteRequest } from 'relay-runtime';
export type SearchType = "DISCUSSION" | "ISSUE" | "ISSUE_ADVANCED" | "ISSUE_HYBRID" | "ISSUE_SEMANTIC" | "REPOSITORY" | "USER" | "USER_LOGIN" | "%future added value";
export type OpenClosedTabsQuery$variables = {
  name: string;
  owner: string;
  query?: string | null | undefined;
  type?: SearchType | null | undefined;
};
export type OpenClosedTabsQuery$data = {
  readonly repository: {
    readonly id: string;
    readonly search: {
      readonly closedIssueCount: number | null | undefined;
      readonly openIssueCount: number | null | undefined;
    };
  } | null | undefined;
};
export type OpenClosedTabsQuery = {
  response: OpenClosedTabsQuery$data;
  variables: OpenClosedTabsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "owner"
},
v2 = {
  "defaultValue": "archived:false assignee:@me sort:updated-desc",
  "kind": "LocalArgument",
  "name": "query"
},
v3 = {
  "defaultValue": "ISSUE_ADVANCED",
  "kind": "LocalArgument",
  "name": "type"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "owner",
        "variableName": "owner"
      }
    ],
    "concreteType": "Repository",
    "kind": "LinkedField",
    "name": "repository",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "aggregations",
            "value": true
          },
          {
            "kind": "Literal",
            "name": "first",
            "value": 0
          },
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
          },
          {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
          }
        ],
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "closedIssueCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "openIssueCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OpenClosedTabsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "OpenClosedTabsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "id": "9b5335baab0566640cfa28c329582507",
    "metadata": {},
    "name": "OpenClosedTabsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9d53eab94a659afb044228b8de635a14";

export default node;
